import { FC } from "react";
import { Chip, styled, Tooltip } from "@mui/material";
export interface ChipTooltipProps {
    remaining: string | React.ReactNode;
    label: string;
    color?: any;
}

const StyledChip = styled(Chip)<{ color?: any }>(({ theme, color }) => ({
    cursor: "pointer", color: color ? (theme.palette as any)[color][700] : theme.palette.grey[700],
    borderColor: color ? (theme.palette as any)[color][200] : (theme.palette as any).secondary[200],
    "& .MuiChip-label": {
        color: color ? (theme.palette as any)[color][700] : theme.palette.grey[700],
    },
    "&:hover": {
        color: color ? (theme.palette as any)[color][700] : theme.palette.grey[700],
        borderColor: color ? (theme.palette as any)[color][200] : theme.palette.secondary.main,
        backgroundColor: color ? (theme.palette as any)[color][200] : (theme.palette as any).secondary[200],
    }
}));

const ChipTooltip: FC<ChipTooltipProps> = ({ remaining, label, color }) => {
    if (!remaining) return null; return (
        <Tooltip title={remaining}>
            <StyledChip label={label}
                size="small"
                variant="outlined"
                color={color} />
        </Tooltip>);
};
export default ChipTooltip;

